import { ProductCardLayoutProps } from "../../types/types";
import { Slot } from "../ProductCardSlot";
import styles from "./Standard.module.scss";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";

export const slotNameMap = {
  BANNER: "banner",
  IMAGE: "image",
  ACTIONS: "actions",
  DRAWER: "drawer",
  MAIN: "main",
  DETAILS: "details",
  FOOTER: "footer",
};

export const Standard = ({
  config,
  product,
  index,
}: ProductCardLayoutProps) => {
  return (
    <article
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={styles["card-container"]}
      data-product-card-layout="Standard"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      id={product?.aliases?.pimProductId} // Needed for wish list scrolling
    >
      <div className={styles["image-container"]}>
        <Slot
          slotName={slotNameMap["BANNER"]}
          className={styles["banner-slot"]}
          config={config}
          product={product}
          index={index}
        />
        <Slot
          slotName={slotNameMap["IMAGE"]}
          className={styles["image-slot"]}
          config={config}
          product={product}
          index={index}
        />
        <Slot
          slotName={slotNameMap["ACTIONS"]}
          className={styles["actions-slot"]}
          config={config}
          product={product}
          index={index}
        />
        <Slot
          slotName={slotNameMap["DRAWER"]}
          className={styles["drawer-slot"]}
          config={config}
          product={product}
          index={index}
        />
      </div>
      <Slot
        slotName={slotNameMap["MAIN"]}
        className={styles["main-slot"]}
        config={config}
        product={product}
        index={index}
      />
      <Slot
        slotName={slotNameMap["DETAILS"]}
        className={styles["details-slot"]}
        config={config}
        product={product}
        index={index}
        bordered={!config["product-card-layout"].props?.hideDetailsBorder}
      />
      <Slot
        slotName={slotNameMap["FOOTER"]}
        className={styles["footer-slot"]}
        config={config}
        product={product}
        index={index}
      />
    </article>
  );
};
